
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$tooltip.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$tooltip.js';
export default __default__;
